define('application',['require','jquery','underscore','chaplin','mediator','i18n','lib/utils','config/application','config/environment','config/backend','controllers/index','lib/error-handler','views/layout','config/pages','models/sidebar','models/poll','models/pages','models/wishlist-result-count'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        Chaplin = require('chaplin'),
        mediator = require('mediator'),
        i18n = require('i18n'),
        // NProgress = require('nprogress'),
        utils = require('lib/utils'),
        applicationConfig = require('config/application'),
        environmentConfig = require('config/environment'),
        backendConfig = require('config/backend');

    require('controllers/index');

    var Application = Chaplin.Application.extend({

        title: applicationConfig.title,

        start: function() {
            var _this = this, callback, callbackWithDelay;

            // Forward up after all ready
            callback = function() {
                Chaplin.Application.prototype.start.apply(_this);
            };

            callbackWithDelay = _.after(2, callback);

            // NProgress.start();

            $('.app-loading').addClass('app-loaded');

            this.initErrorHandler();
            this.initConfig()
                .done(function() {
                    _this.initAuth(callbackWithDelay);
                    _this.initLocale(callbackWithDelay);
                })
                .fail(function() {
                    mediator.applicationError = true;
                    _this.initLocale(callback);
                });
        },

        initErrorHandler: function() {
            var callback,
                _this = this,
                ErrorHandler = require('lib/error-handler');

            mediator.errorHandler = new ErrorHandler();
            mediator.errorHandler.isLocked = true;

            callback = function() {
                _this.unsubscribeEvent('messagesView:ready', callback);

                mediator.errorHandler.isLocked = false;
                mediator.errorHandler.publishCurrentErrors();
            };

            this.subscribeEvent('messagesView:ready', callback);
        },

        initAuth: function(callback) {
            var _this = this,
                modifiedCallback,
                accessToken = window.localStorage.getItem('accessToken');

            if (!accessToken) {
                callback();
            } else {
                modifiedCallback = function() {
                    _this.unsubscribeEvent('signinStatus', modifiedCallback);
                    callback();
                };
                this.subscribeEvent('signinStatus', modifiedCallback);
                mediator.signin(accessToken);
            }

            this.subscribeEvent('errorHandler:catch', function(error) {
                // logout on unauth
                if (mediator.isAuthorized() && error.code === 401) {
                    mediator.signout();
                    // Chaplin.helpers.redirectTo('sessions#signout');
                }
            });
        },

        initConfig: function() {
            return utils
                .ajax(environmentConfig[applicationConfig.environment].api.root + '/config')
                .done(function(response) {
                    _.extend(backendConfig, response);
                });
        },

        initLocale: function(callback) {
            var localeCallback,
                prepareCallback;

            prepareCallback = function(data) {
                var processCallback = function(data, locale) {
                    var resStore = {},
                        ns = 'translation';

                    if (!locale) {
                        locale = applicationConfig.locale;
                    }

                    resStore[locale] = {};
                    resStore[locale][ns] = data;

                    i18n.init({
                        lng: locale,
                        resStore: resStore
                    });

                    callback();
                };

                // If error en locale by default
                if (!data) {
                    require(['json!config/locales/en.json'], function(data) {
                        processCallback(data, 'en');
                    });
                } else {
                    processCallback(data);
                }
            };

            localeCallback = function(data) {
                utils
                    .ajax(environmentConfig[applicationConfig.environment].api.root + '/locales/' + applicationConfig.locale)
                    .done(function(response) {
                        prepareCallback(data ? _.extend({}, data, response) : response);
                    })
                    .fail(function() {
                        prepareCallback(data);
                    });
            };

            require(['json!config/locales/' + applicationConfig.locale + '.json'], localeCallback, function() {
                localeCallback(null);
            });
        },

        initLayout: function(options) {
            var Layout = require('views/layout');

            this.layout = new Layout(_.defaults(options, { title: this.title }));
        },

        initMediator: function() {
            var pages = require('config/pages'),

                Sidebar     = require('models/sidebar'),
                Poll        = require('models/poll'),
                Pages       = require('models/pages'),

                WishlistResultCount = require('models/wishlist-result-count');

            mediator.channel = null;

            $( window ).unload(function() {
                mediator.closeChannel();
            });

            mediator.pages = new Pages(pages);

            mediator.activeRoute = null;
            mediator.user = null;
            mediator.userSettings = null;
            mediator.errorHandler = null;
            mediator.applicationError = false;
            mediator.poll = new Poll();
            mediator.breadcrumb = new Chaplin.Model({ items: [] });
            mediator.sidebar = new Sidebar({ expanded: true });
            mediator.mainMenu = new Chaplin.Collection(mediator.pages.where({ mainMenu: true }));

            mediator.wishlistResultCount = new WishlistResultCount();
            mediator.wishlistResultCount.on('change:count', function(model, value) {
                mediator.mainMenu.findWhere({ name: 'wishlist' }).set('status', value);
            });

            Chaplin.Application.prototype.initMediator.call(this, arguments);
        }
    });

    return Application;
});
